import { render } from "./Risk.vue?vue&type=template&id=6143c977&scoped=true"
import script from "./Risk.vue?vue&type=script&lang=js"
export * from "./Risk.vue?vue&type=script&lang=js"

import "./Risk.vue?vue&type=style&index=0&id=6143c977&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6143c977"]])

export default __exports__